<template>
  <div
    class="parent"
    v-lazy:background-image="{
      src: require('./../img/background.png'),
      loading:require('./../img/background.jpg'),
    }"
  >
    <div class="divContainer">
      <subject-flow-widge
        subject="大数据学科"
        :project="name"
        :routerLink="routerLink"
      ></subject-flow-widge>
      <div class="divContent">
        <div class="divC">
        <pre-publish-widge :data="date" color="rgba(51, 51, 134, 1)"  bgColor="#e1eeff"></pre-publish-widge>
          <div class="divName">{{ name }}</div>
          <div class="divDesc">{{ desc }}</div>
        </div>
      </div>
      <div class="divProject">
        <div class="divIndustry">
          <div class="divIndustryContainer">
            <img :src="logo" />
            <span class="spanDesc">{{ logoDesc }}</span>
          </div>
        </div>
        <div class="divNum">
          <ul>
            <li v-for="(item, index) in itemList" :key="index">
              <p class="pNum">
                {{ item.num }} <em>{{ item.unit }}</em>
              </p>

              <p class="pDesc">{{ item.type }}</p>
            </li>
          </ul>
        </div>
        <div class="divVideo" @click="handleVideo(video)" v-if="video"> 
          <div class="divDisplay">
            <img src="./../../common/img/video_green.png" />
          </div>
          <div class="videoDesc">项目介绍</div>
        </div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
  </div>
</template>

<script>
import MenuAdd from "./../../../../components/video";
import subjectFlowWidge from "./../../../../components/subjectFlowWidge";
import prePublishWidge from './../../common/components/prePublishWidge'
export default {
  components: {
    MenuAdd,
    subjectFlowWidge,
    prePublishWidge
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    logo: {
      type: String,
      default: "",
    },
    logoDesc: {
      type: String,
      default: "",
    },
    itemList: {
      type: Array,
      default: () => {},
    },
    video: {
      type: String,
      default: "",
    },
  },
  computed: {
    routerLink() {
      return {
        path: "/bigdata",
      };
    }
  },
  methods: {
    handleVideo(url) {
      this.$trackEvent("视频介绍", "点击视频")
      let obj = {
        url: url,
      };
      this.$refs.editMenu.dialogFormV(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/headFirstWidget.scss";
</style>
